import { LocalizedText, RichSubstitutes } from './modern/text/LocalizedText';

export const lt = (textKey: Mews.TextKey | Mews.TextKeyUnion, substitutes?: RichSubstitutes) => (
    <LocalizedText textKey={textKey as Mews.TextKey} substitutes={substitutes} />
);
